import { MaskedLine } from "@/components/MaskedLine";
import { Reveal } from "@/components/Reveal";

export const Statement = () => (
  <section
    data-testid="hero-statement-section"
    className="relative py-28 sm:py-36 lg:py-48 px-5 sm:px-8 overflow-hidden"
  >
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <p className="mono text-[11px] tracking-[0.28em] uppercase text-neutral-500 mb-10">The Novo Standard</p>
      </Reveal>
      <h2 className="font-display font-extrabold uppercase tracking-tighter leading-[0.95] text-[13.5vw] sm:text-[11vw] lg:text-[8.5rem]">
        <MaskedLine className="pb-1" innerClassName="text-neutral-50">
          Why limit
        </MaskedLine>
        <MaskedLine className="pb-2" innerClassName="text-outline" delay={0.12}>
          your business?
        </MaskedLine>
      </h2>
      <Reveal delay={0.3} className="mt-10 max-w-xl">
        <p className="text-neutral-400 text-base sm:text-lg leading-relaxed">
          Your website should never be the thing holding your business back.
        </p>
      </Reveal>
    </div>
  </section>
);
